/*import "./PostCardImg.scss";*/
import Link from "next/link";
import { FormattedPost } from "@/lib/blog";

const PostCardImg = ({
  post: { featuredImage = undefined, link = "#" },
}: {
  post: { featuredImage?: string; link: string };
}) => (
  <Link className="card-img" href={link}>
    {featuredImage && (
      <img
        src={featuredImage}
        className="card-img-top img-fluid"
        alt="Featured"
      />
    )}
  </Link>
);

export default PostCardImg;
